import React from 'react'
import PropTypes from 'prop-types'

export default function PubMedPageItems(props) {
  const { itemsPerPage, handleChangeSelectItems, customWidth } = props
  //console.log({itemsPerPage})
  return (
    <div className="pagination-select-outer-wrapper">
      <span className="pagination-select-label">Items Per Page:&nbsp;</span>
      <span style={{ width: customWidth ? "35%" : "30%" }}>
        <select
          style={{ outline: "none" }}
          className="pagination-select-wrapper"
          onChange={e => handleChangeSelectItems(e.target.value)}
          defaultValue={itemsPerPage}
          value={itemsPerPage}
        >
          <option>10</option>
          <option>25</option>
          <option>50</option>
          <option>75</option>
          <option>100</option>
          <option>200</option>
          <option>400</option>
          <option>500</option>
          <option>600</option>
          <option>700</option>
          <option>800</option>
          <option>900</option>
          <option>1000</option>
        </select>
      </span>
    </div>
  )
}
PubMedPageItems.propTypes = {
  itemsPerPage: PropTypes.string.isRequired,
  handleChangeSelectItems: PropTypes.func
}

